import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import DeleteConfirmDialog from '../dialog/DeleteConfirmDialog.vue';
import { ref,  onMounted } from 'vue';
import i18n from "@/locale/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteButton',
  props: {
    label: {
        type: String,
        default: ''
    },
},
  emits: ["click", "doDelete"],
  setup(__props, { emit }: { emit: ({
  (event: 'click', data: { event: MouseEvent }): void;
  (event: 'doDelete' ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const t = i18n.global.t;

const buttonLabel = ref('');

const confirmDialogShow = ref(false);





onMounted(() => {
    if (props.label === '') {
        buttonLabel.value = t("COMMON.BUTTON.DELETE");
    } else {
        buttonLabel.value = props.label;
    }
})

const onClick = (event: MouseEvent) => {
    // HOTELOS_DEV-617 start
    // confirmDialogShow.value = true;
    emit('doDelete');
    // HOTELOS_DEV-617 end
}

const deleteDialogHide = () => {
    confirmDialogShow.value = false;
}

const deleteCallback = () => {
    confirmDialogShow.value = false;
    emit('doDelete');
}


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: "p-button-danger",
      icon: "pi pi-times",
      label: buttonLabel.value,
      onClick: onClick
    }, null, 8, ["label"]),
    _createVNode(DeleteConfirmDialog, {
      showFlag: confirmDialogShow.value,
      onHideDeleteDialog: deleteDialogHide,
      onDoDelete: deleteCallback
    }, null, 8, ["showFlag"])
  ], 64))
}
}

})